import IdentityVerificationInitial from '@perpay-web/fintech/components/screens/IdentityVerificationRequired/IdentityVerificationInitial';

const CardApplicationIdentityVerificationContainer = () => (
    <IdentityVerificationInitial />
);

export default CardApplicationIdentityVerificationContainer;
